/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  FETCHING_ACTIVE_STUDIES,
  FETCHED_ACTIVE_STUDIES,
  FETCH_ACTIVE_STUDIES_ERROR,
  FETCHED_SIGNED_CONSENTINGS_NO_ERROR,
  FETCHED_SIGNED_CONSENTINGS_NO,
  RECEIVED_UNASSIGNED_STUDIES,
  RECEIVED_UNASSIGNED_STUDIES_ERROR
} from '../actions/actionTypes';

const initialStudyState = {
  isFetching: null,
  isFetchingUnassigned: null,
  rows: [],
  error: null,
  errorUnassigned: null,
  signedConsentingsNo: 0
};

const studyReducer = (state = initialStudyState, action) => {
  switch (action.type) {
    case FETCHING_ACTIVE_STUDIES:
      return Object.assign({}, state, { isFetching: true });
    case FETCHED_ACTIVE_STUDIES:
      return Object.assign({}, state, { rows: action.payload, isFetching: false, error: null });
    case FETCH_ACTIVE_STUDIES_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case RECEIVED_UNASSIGNED_STUDIES:
      return Object.assign({}, state, {
        isFetchingUnassigned: false,
        errorUnassigned: null
      });
    case RECEIVED_UNASSIGNED_STUDIES_ERROR:
      return Object.assign({}, state, {
        isFetchingUnassigned: false,
        errorUnassigned: action.payload,
        unassignedStudies: []
      });
    case FETCHED_SIGNED_CONSENTINGS_NO:
      return Object.assign({}, state, { signedConsentingsNo: action.payload });
    case FETCHED_SIGNED_CONSENTINGS_NO_ERROR:
      return Object.assign({}, state, { signedConsentingsNo: 0 });
    default:
      return state;
  }
};

export default studyReducer;
